import api from "../_api";

const actions = {
    membershipRequest: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("MEMBERSHIP_LOADING");

            api.membership(payload)
                .then(resp => {
                    commit("MEMBERSHIP_SUCCESS", resp.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("MEMBERSHIP_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    payRego: ({ commit, dispatch, state }, payload) => {
        let data = {
            cardData: payload.cardPayload,
            couponCart: payload.couponCart,
            donationCart: payload.donationCart,
            membershipCart: state.membershipCart,
            pickRego: payload.pickRego,
            sport: payload.sport,
        };

        return new Promise((resolve, reject) => {
            commit("PAYMENT_LOADING");

            api.payrego(data)
                .then(resp => {
                    commit("PAYMENT_SUCCESS", resp.data);
                    dispatch("user/userRequest", null, { root: true });
                    resolve(resp.data.data.o_id);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("PAYMENT_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    clearPaymentErrors: ({ commit }) => {
        commit("CLEAR_PAYMENT_ERRORS");
    },
};

export default actions;
